import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonsService} from "@core/service/commons.service";
import {TenderMatDetailService} from "../../../routes/jy-srm/tender-mat/tender-mat-detail.service";
import {ActivatedRoute} from "@angular/router";
import {TenderMatService} from "../../../routes/jy-srm/tender-mat/tender-mat.service";
import {Pagination} from "@core/bean/pagination";
import {PageData} from "@core/bean/page-data";
import {ArticleService} from "../../../routes/jy-content/article/service/article.service";
import {SupplierRegisterService} from "../../../routes/jy-srm/supplier/supplier-register/supplier-register.service";
import {ArticleViewService} from "@shared/components/article-view/article-view.service";

@Component({
  selector: 'app-tender-mat-detail',
  templateUrl: './tender-mat-detail.component.html',
  styles: []
})
export class TenderMatDetailComponent implements OnInit {
  //加载动画
  public loading: boolean = false;
  tenderMatNoticeDetailPagination: Pagination = new Pagination();
  @Input() tenderMatIsVisible;
  @Input() tenderMatId;
  @Input() articleDetail;
  @Input() noLogin:boolean;
  @Output() private closeModel1 = new EventEmitter();

  //采购订单详情
  public orderObj: any = {
    attachment: {},
    tenderMatNoticeDetailList: [],
    remark: '',
    createdBy: '',
    docNo: '',
    matSubClass:''
  };
  constructor(public commonsService:CommonsService,public tenderMatService:TenderMatService,
              private activatedRoute: ActivatedRoute,
              private articleService:ArticleService,
              private supplierRegisterService:SupplierRegisterService,
              private articleViewService:ArticleViewService) { }

  ngOnInit() {

  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.tenderMatIsVisible &&this.tenderMatId) {
      this.loading = true;
      this.supplierRegisterService.getTenderMat(this.tenderMatId).subscribe(data => {
          this.orderObj = data;
          this.tenderMatNoticeDetailPagination.pageData = new PageData(this.orderObj.tenderMatNoticeDetailList.length, this.orderObj.tenderMatNoticeDetailList);
          this.loading = false;
        }, () => this.loading = false,
        () => this.loading = false)
      let viewObj = {
        'fkType':'ARTICLE',
        'fkId':this.articleDetail.id
      };
      this.articleViewService.addFk(viewObj).subscribe((res) => {
        if(this.articleDetail && (this.articleDetail.viewCount || this.articleDetail.viewCount === 0)){
          this.articleDetail.viewCount++;
        }
      });
    }

  }
  handleCancel(){
    this.tenderMatNoticeDetailPagination.pageData=new PageData(0,[]);
    this.orderObj=null;
    this.closeModel1.emit();
  }
  handleOk(){
    this.tenderMatNoticeDetailPagination.pageData=new PageData(0,[]);
    this.orderObj=null;
    this.closeModel1.emit();
  }

  //  浏览量弹框
  public viewVisible:boolean = false;
//  打开浏览量弹框
  opernArticleView(){
    this.viewVisible = true;
  }
//  关闭浏览量弹框
  closeView(){
    this.viewVisible = false;
  }
  // 评论弹框
  public componentVisible:boolean = false;
  //打开评论框
  openArticleComponent(){
    this.componentVisible = true;
  }
  //关闭评论框
  closeComment(){
    this.componentVisible = false;
      this.articleService.get(this.articleDetail.id).subscribe((data) =>{
        this.articleDetail.commentsCount = data.commentsCount;
      })
  }
}


